module.exports = {
	"name": "spectra-data",
	"version": "3.0.7",
	"description": "spectra-data project - manipulate spectra",
	"keywords": [
		"spectra-data",
		"project"
	],
	"author": "Andres Castillo",
	"contributors": [
		"Michaël Zasso",
		"Luc Patiny"
	],
	"repository": "cheminfo-js/spectra-data",
	"bugs": {
		"url": "https://github.com/cheminfo-js/spectra-data/issues"
	},
	"homepage": "https://github.com/cheminfo-js/spectra-data",
	"license": "MIT",
	"main": "./src/index.js",
	"scripts": {
		"eslint": "eslint src test --cache",
		"eslint-fix": "npm run eslint -- --fix",
		"test": "npm run test-mocha && npm run eslint",
		"test-mocha": "mocha --require should --reporter mocha-better-spec-reporter --recursive src/**/__tests__/**/*.js",
		"build": "cheminfo build"
	},
	"devDependencies": {
		"cheminfo-tools": "^1.13.0",
		"eslint": "^3.9.1",
		"eslint-config-cheminfo": "^1.5.2",
		"eslint-plugin-no-only-tests": "^1.1.0",
		"mocha": "^3.1.2",
		"mocha-better-spec-reporter": "^3.0.1",
		"nmr-predictor": "https://github.com/cheminfo-js/nmr-predictor/",
		"should": "^11.1.1"
	},
	"dependencies": {
		"babel-core": "^6.24.1",
		"babel-loader": "^7.0.0",
		"brukerconverter": "^1.0.1",
		"jcampconverter": "^2.4.5",
		"ml-array-utils": "^0.3.0",
		"ml-curve-fitting": "0.0.7",
		"ml-fft": "^1.3.5",
		"ml-gsd": "^2.0.1",
		"ml-matrix-peaks-finder": "^0.2.1",
		"ml-simple-clustering": "0.1.0",
		"ml-stat": "^1.3.0",
		"nmr-simulation": "^1.0.0"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 156
// module chunks = 0